// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{ label:'联系人:',spanRows:8,type:'input',modelValue:'conerName'},
	{ label:'联系人电话:',spanRows:8,type:'input',modelValue:'conerTel'},
	{ label:'联系人关系:',spanRows:8,type:'select',modelValue:'conerRltsId',op:'rltsEntitiesOptions'},
	
	{ label:'联系人证件:',spanRows:8,type:'select',modelValue:'conerCertTypeId',op:'certypeOptions'},
	{ label:'证件号:',spanRows:16,type:'input',modelValue:'conerCertNo'},
	
	// { label:'联系人地址:',spanRows:12,type:'cascader',modelValue:'financialClassIdName',op:"ClassIdOptions",},
	
	{ label:'客户单位:',spanRows:8,type:'input',modelValue:'phrUnt'},
	// { label:'推荐人:',spanRows:8,type:'input',modelValue:'priceCode',op:'selectOptions'},
	// { label:'人员类型:',spanRows:8,type:'input',iconDialogVisible:true,modelValue:'chargeProjectName',op:'selectChanceAll'},
	
	// { label:'建档机构:',spanRows:6,type:'input',modelValue:'excludedContent'},
	// { label:'建档人:',spanRows:6,type:'input',modelValue:'simpCode'},
	// { label:'建档时间:',spanRows:6,type:'date',modelValue:'financialClassIdName',op:"ClassIdOptions"},
	{ label:'状态:',spanRows:6,type:'select',modelValue:'state',op:"statusOption"},
	
	]

